import { useState } from 'react';
import { fileUrl } from '../api/client';
import { colors } from '../theme';

/**
 * Image gallery for the detail pages.
 *
 * Handles the two cases the seeded catalogue actually hits: a listing with no
 * photos at all, and a photo whose file has gone missing. Both land on the same
 * labelled placeholder rather than a bare emoji in an empty frame or the
 * browser's broken-image glyph, either of which reads as a bug.
 */
const Gallery = ({
  images = [], fallback = '📦', contain, badge, emptyLabel = 'No photo yet',
}) => {
  const [index, setIndex] = useState(0);
  const [broken, setBroken] = useState({});

  const usable = images.filter((_, i) => !broken[i]);
  const current = images[index];
  const showImage = current && !broken[index];

  return (
    <div>
      <div className={`media ${contain ? 'contain' : ''}`}>
        {showImage ? (
          <img
            src={fileUrl(current)}
            alt=""
            onError={() => setBroken((b) => ({ ...b, [index]: true }))}
          />
        ) : (
          <div className="media-empty">
            <span className="glyph">{fallback}</span>
            <span className="label">{emptyLabel}</span>
          </div>
        )}
        {badge}
      </div>

      {usable.length > 1 ? (
        <div className="rail thumb-strip" style={{ marginTop: 10 }}>
          {images.map((u, i) => (broken[i] ? null : (
            <button
              key={`${u}-${i}`}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`Photo ${i + 1}`}
              style={{
                border: `2px solid ${i === index ? colors.primary : 'transparent'}`,
                borderRadius: 10, padding: 0, background: 'none', lineHeight: 0,
              }}
            >
              <img src={fileUrl(u)} alt="" onError={() => setBroken((b) => ({ ...b, [i]: true }))} />
            </button>
          )))}
        </div>
      ) : null}
    </div>
  );
};

export default Gallery;
